"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3740],{

/***/ 20028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87043);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var ConnErrorState = function ConnErrorState(_ref) {
  var onRetry = _ref.onRetry;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
    flexDirection: "column",
    justifyContent: "space-around",
    "data-testid": "ConnErrorState-Root"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, null, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
    title: "Imagem ilustrativa - Conex\xE3o remota com falha",
    alt: "Imagem ilustrativa - Conex\xE3o remota com falha",
    width: "100%",
    height: "50vh",
    src: "https://wx.mlcdn.com.br/site/chat/cable-disconnected-colorful.svg"
  })), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    textAlign: "center",
    p: "2",
    role: "alert",
    "aria-live": "assertive"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    fontSize: 6,
    fontWeight: "bold",
    mb: 4
  }, "Erro inesperado"), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    fontSize: 2
  }, "Isso pode ocorrer por uma instabilidade ou problema de conex\xE3o tempor\xE1ria.")), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
    textAlign: "center",
    p: "2"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    fontSize: 2,
    mb: 3
  }, "Por favor, aguarde alguns instantes e tente novamente."), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
    full: true,
    centered: true,
    onClick: onRetry,
    size: "large",
    uppercase: false
  }, "Tentar novamente")));
};
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(ConnErrorState));

/***/ }),

/***/ 7282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ChatInbox_ChatInbox; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(282);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatLoading/index.js + 2 modules
var ChatLoading = __webpack_require__(53706);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatAlternateState/ConnErrorState.js
var ConnErrorState = __webpack_require__(20028);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatInfiniteList/index.js + 8 modules
var ChatInfiniteList = __webpack_require__(65938);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js + 2 modules
var Card = __webpack_require__(27439);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/NumberedButton/index.js + 2 modules
var NumberedButton = __webpack_require__(97851);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatContactCard/ChatContactCard.style.js

var _templateObject, _templateObject2, _templateObject3;



var CardBadgeStyled = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > div > button > div {\n    height: 20px;\n    width: auto;\n    min-width: 20px;\n    border-radius: 10px;\n    top: 0;\n    bottom: auto;\n    z-index: 1;\n    transform-origin: 100% 0%;\n    transform: scale(1) translate(35%, -35%);\n  }\n"])));
var CardStyled = (0,styled_components_browser_esm["default"])(Card/* default */.ZP)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  border-radius: 0;\n  border-bottom: 1px solid ", ";\n"])), (0,stereo_ui_styles_build_esm.themeGet)('colors.lightSilver'));
var CardTextDate = (0,styled_components_browser_esm["default"])(Card/* default.Subtitle */.ZP.Subtitle)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  white-space: nowrap;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatContactCard/ChatContactCard.js







var ChatContactCard = function ChatContactCard(_ref) {
  var name = _ref.name,
    description = _ref.description,
    date = _ref.date,
    onClick = _ref.onClick,
    badgeCount = _ref.badgeCount;
  return react.createElement(CardStyled, {
    onClick: onClick,
    "data-testid": "chat-contact-card"
  }, react.createElement(Flex/* default */.Z, {
    flexDirection: "row",
    gap: 3,
    alignItems: "center",
    width: "100%",
    padding: "16px 20px"
  }, react.createElement(CardBadgeStyled, null, react.createElement(NumberedButton/* default */.Z, {
    amount: badgeCount,
    backgroundColor: "transparent",
    counterColor: "#0086ff",
    fontColor: "#fff",
    truncateAmountThreshold: 10,
    nullable: false
  }, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    name: "SellerStore",
    width: 40,
    height: 40
  }))), react.createElement(Flex/* default */.Z, {
    justifyContent: "space-between",
    gap: 2,
    flex: 1
  }, react.createElement("div", null, react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
    "data-testid": "chat-contact-card-name",
    fontSize: "1rem",
    lineHeight: "1.125rem",
    fontWeight: 500,
    lines: 1,
    marginTop: 0,
    truncate: true
  }, name), description && react.createElement(Card/* default.Subtitle */.ZP.Subtitle, {
    color: "scratched",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1rem",
    lines: 1,
    marginTop: 1,
    truncate: true
  }, description)), date && react.createElement(CardTextDate, {
    color: "scratched",
    fontWeight: 400,
    marginTop: 0,
    whiteSpace: "nowrap"
  }, date))));
};
ChatContactCard.defaultProps = {
  badgeCount: 0,
  date: undefined,
  description: undefined
};
 false ? 0 : void 0;
/* harmony default export */ var ChatContactCard_ChatContactCard = ((0,react.memo)(ChatContactCard));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatContactCard/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatAlternateState/EmptyState.style.js

var EmptyState_style_templateObject, EmptyState_style_templateObject2;


var IconContainer = styled_components_browser_esm["default"].span(EmptyState_style_templateObject || (EmptyState_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var IconBadge = styled_components_browser_esm["default"].span(EmptyState_style_templateObject2 || (EmptyState_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  background-color: ", ";\n  border-radius: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  right: 0;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getBackgroundColor)('primary')(props);
}, (0,stereo_ui_styles_build_esm.themeGet)('radii.circle'));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatAlternateState/EmptyState.js





var EmptyState = function EmptyState(props) {
  return react.createElement(atoms/* Flex */.kC, (0,esm_extends/* default */.Z)({}, props, {
    flexDirection: "column",
    justifyContent: "center",
    "data-testid": "EmptyState-Root"
  }), react.createElement(atoms/* Box */.xu, {
    textAlign: "center"
  }, react.createElement(IconContainer, null, react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
    name: "SellerStore",
    height: "104px",
    width: "104px"
  }), react.createElement(IconBadge, {
    title: "N\xFAmero de conversas: 0"
  }, react.createElement(atoms/* Text */.xv, {
    color: "text.white",
    fontWeight: "bold"
  }, "0")))), react.createElement(atoms/* Box */.xu, {
    textAlign: "center",
    p: "2"
  }, react.createElement(atoms/* Text */.xv, {
    fontSize: 5,
    lineHeight: "big",
    fontWeight: "bold",
    mb: 4
  }, "Voc\xEA ainda n\xE3o tem conversas com lojistas")));
};
/* harmony default export */ var ChatAlternateState_EmptyState = ((0,react.memo)(EmptyState));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatConversationList/ConversationList.style.js

var ConversationList_style_templateObject;


var EmptyStateStyled = (0,styled_components_browser_esm["default"])(ChatAlternateState_EmptyState)(ConversationList_style_templateObject || (ConversationList_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatConversationList/ConversationList.js


var _excluded = ["items", "onClickItem", "onLoadNextItems", "hasNextItems", "loading"];






var ConversationList = function ConversationList(_ref) {
  var items = _ref.items,
    onClickItem = _ref.onClickItem,
    onLoadNextItems = _ref.onLoadNextItems,
    hasNextItems = _ref.hasNextItems,
    loading = _ref.loading,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var itemCount = items.length;
  var getItemSize = function getItemSize() {
    return 69;
  };
  var renderRow = function renderRow(index) {
    var _item$lastMessage;
    var item = items[index];
    return react.createElement(ChatContactCard_ChatContactCard, {
      name: item.toUser.fullName,
      description: item == null ? void 0 : (_item$lastMessage = item.lastMessage) == null ? void 0 : _item$lastMessage.content,
      date: item.lastInteractionAt,
      onClick: function onClick() {
        return onClickItem(item, index);
      },
      badgeCount: item.unreadFromCount
    });
  };
  return react.createElement(ChatInfiniteList/* InfiniteListContainer */.L, (0,esm_extends/* default */.Z)({
    "data-testid": "chat-conversation-list"
  }, restProps, {
    bg: "background.white"
  }), react.createElement(ChatInfiniteList/* InfiniteList */.$, {
    itemCount: itemCount,
    itemSize: getItemSize,
    renderRow: renderRow,
    onLoadNextItems: onLoadNextItems,
    hasNextItems: hasNextItems,
    loading: loading
  }), itemCount === 0 && react.createElement(EmptyStateStyled, null), loading && react.createElement(ChatLoading/* default */.Z, null));
};
ConversationList.defaultProps = {
  hasNextItems: undefined,
  loading: undefined,
  onLoadNextItems: undefined
};
 false ? 0 : void 0;
ConversationList.ssr = false;
/* harmony default export */ var ChatConversationList_ConversationList = ((0,react.memo)(ConversationList));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatConversationList/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatConversation/ChatConversation.style.js


var ChatConversation_style_templateObject, ChatConversation_style_templateObject2;




var ConversationStyled = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    flexDirection: 'column',
    fontFamily: '"MagaluTextos", sans-serif',
    height: '100%',
    margin: 'auto',
    maxWidth: '1280px',
    width: '100%'
  }, props);
})(ChatConversation_style_templateObject || (ChatConversation_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var FilterInputStyled = (0,styled_components_browser_esm["default"])(molecules/* FilterInput */.HS)(ChatConversation_style_templateObject2 || (ChatConversation_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 12px;\n  margin: 8px 8px 32px 8px;\n  border: none;\n\n  & div {\n    height: 48px;\n  }\n\n  div & :focus {\n    outline: 1px solid ", ";\n  }\n"])), (0,stereo_ui_styles_build_esm.getBackgroundColor)('opacityBlue'));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatConversation/ChatConversation.js









var ChatConversation = function ChatConversation(_ref) {
  var onClickItem = _ref.onClickItem,
    userData = _ref.userData,
    staticProps = _ref.staticProps;
  var userId = userData.id;
  var _useState = (0,react.useState)(''),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useChatConversations = (0,graphql_build_esm.useChatConversations)({
      search: search,
      staticProps: staticProps,
      userId: userId
    }),
    items = _useChatConversations.items,
    loading = _useChatConversations.loading,
    error = _useChatConversations.error,
    hasNextPage = _useChatConversations.hasNextPage,
    fetchNextPage = _useChatConversations.fetchNextPage,
    fetchMore = _useChatConversations.fetchMore,
    refetch = _useChatConversations.refetch;
  (0,react.useEffect)(function () {
    fetchMore();
  }, [search]);
  var handleSearch = function handleSearch(event) {
    setSearch(event.target.value);
  };
  var handleClear = function handleClear() {
    setSearch('');
  };
  var onSearch = debounce_default()(handleSearch, 500);
  if (error) return react.createElement(ConnErrorState/* default */.Z, {
    onRetry: refetch
  });
  return react.createElement(ConversationStyled, {
    bg: "background.base"
  }, react.createElement(FilterInputStyled, {
    label: "lojista",
    onChange: onSearch,
    onClearInput: handleClear
  }), !items && loading && react.createElement(ChatLoading/* default */.Z, {
    align: "center"
  }), items && react.createElement(ChatConversationList_ConversationList, {
    loading: loading,
    items: items,
    onClickItem: onClickItem,
    hasNextItems: hasNextPage,
    onLoadNextItems: fetchNextPage
  }));
};
 false ? 0 : void 0;
/* harmony default export */ var ChatConversation_ChatConversation = ((0,react.memo)(ChatConversation));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatConversation/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatInbox/ChatInbox.js










var ChatInbox = function ChatInbox(_ref) {
  var structure = _ref.structure,
    staticProps = _ref["static"];
  var route = structure.route;
  var _useChatUserData = (0,hooks/* useChatUserData */.Cv)({
      structure: structure
    }),
    userData = _useChatUserData.data,
    loading = _useChatUserData.loading;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var hasRedirect = !!(route == null ? void 0 : route.sellerId);
  (0,react.useEffect)(function () {
    if (hasRedirect) {
      var url = "/chat-com-lojista/p/".concat(route.sellerId, "/").concat((route == null ? void 0 : route.productId) ? route.productId : '');
      router_default().replace(url);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (userData) {
      var _structure$cookies, _structure$cookies2;
      publish('sellerchat:inbox:conversations:onview', {
        userId: userData.id,
        userIsLogged: userData.isLogged,
        userLocation: (0,esm_extends/* default */.Z)({}, structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.location, {
          zipCode: structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.zipCode
        })
      });
    }
  }, [userData]);
  var onClickItem = function onClickItem(item) {
    var _item$toUser;
    publish('sellerchat:inbox:conversations:onclick', {
      sellerId: item.toUser.refKey,
      userId: userData.id
    });
    (0,esm/* routePush */.dY)({
      path: "/chat-com-lojista/p/".concat((_item$toUser = item.toUser) == null ? void 0 : _item$toUser.refKey, "/"),
      spa: true
    });
  };
  if (hasRedirect || loading) {
    return react.createElement(atoms/* PageLoading */.SX, null);
  }
  if (!(userData == null ? void 0 : userData.isLogged)) {
    return react.createElement(atoms/* Flex */.kC, {
      width: "100%",
      justifyContent: "center",
      alignItems: "center"
    }, react.createElement(atoms/* Text */.xv, null, "Usu\xE1rio n\xE3o autorizado"));
  }
  return react.createElement(ChatConversation_ChatConversation, {
    onClickItem: onClickItem,
    userData: userData,
    staticProps: staticProps
  });
};
ChatInbox.defaultProps = {
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
ChatInbox.ssr = true;
/* harmony default export */ var ChatInbox_ChatInbox = ((0,withLayoutProps/* default */.Z)(ChatInbox));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatInbox/index.js


/***/ }),

/***/ 65938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ ChatInfiniteList_InfiniteList; },
  "L": function() { return /* reexport */ InfiniteListContainer; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(36631);
// EXTERNAL MODULE: ../../node_modules/react-virtualized-auto-sizer/dist/react-virtualized-auto-sizer.esm.js
var react_virtualized_auto_sizer_esm = __webpack_require__(6738);
// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(36076);
// EXTERNAL MODULE: ../../node_modules/lodash/noop.js
var noop = __webpack_require__(34291);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatVirtualizedList/useListItemSize.js



var useListItemSize = function useListItemSize(listRef) {
  var listItemsMetadataCache = (0,react.useRef)({});
  var resizeListItemHeight = function resizeListItemHeight(index, context) {
    var height = context.elementRef.offsetHeight;
    var windowWidth = context.windowWidth,
      id = context.id;
    listItemsMetadataCache.current = (0,esm_extends/* default */.Z)({}, listItemsMetadataCache.current, (0,defineProperty/* default */.Z)({}, id, {
      height: height,
      id: id,
      windowWidth: windowWidth
    }));
    listRef.current.resetAfterIndex(index);
  };
  var validateCache = function validateCache(index, context) {
    var cacheItem = listItemsMetadataCache.current[context.id];
    var validationOne = context.windowWidth !== cacheItem.windowWidth;
    var validationTwo = context.elementRef.offsetHeight !== cacheItem.height;
    if (validationOne || validationTwo) {
      resizeListItemHeight(index, context);
    }
  };
  var setItemSize = (0,react.useCallback)(function (index, context) {
    if (listRef.current && context) {
      if (listItemsMetadataCache.current[context.id]) {
        validateCache(index, context);
      } else {
        resizeListItemHeight(index, context);
      }
    }
  }, [listRef.current]);
  var getItemSize = function getItemSize(id) {
    if (listItemsMetadataCache.current[id]) {
      return listItemsMetadataCache.current[id].height;
    }
    return 0;
  };
  return [getItemSize, setItemSize];
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatVirtualizedList/VirtualizedListRow.js



var VirtualizedListRow = function VirtualizedListRow(props) {
  var rowRef = (0,react.useRef)();
  var data = props.data,
    index = props.index,
    id = props.id,
    onSetSize = props.onSetSize,
    windowWidth = props.windowWidth;
  var renderRow = data.renderRow;
  (0,react.useEffect)(function () {
    onSetSize(index, {
      elementRef: rowRef.current,
      id: id,
      windowWidth: windowWidth
    });
  }, [onSetSize, windowWidth, index]);
  return react.createElement("div", {
    ref: rowRef
  }, renderRow(index));
};
VirtualizedListRow.defaultProps = {
  onSetSize: (noop_default())
};
 false ? 0 : void 0;
VirtualizedListRow.ssr = false;
/* harmony default export */ var ChatVirtualizedList_VirtualizedListRow = ((0,react.memo)(VirtualizedListRow));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatVirtualizedList/VirtualizedList.js




var _excluded = ["renderRow", "listRef", "onScroll"];









var createItemData = (0,memoize_one_esm/* default */.Z)(function (renderRow) {
  return {
    renderRow: renderRow
  };
});
var assignRefTo = function assignRefTo() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (elementRef) {
    refs.forEach(function (useref) {
      if (typeof useref === 'function') {
        useref(elementRef);
      }
      if ((0,esm_typeof/* default */.Z)(useref) === 'object') {
        useref.current = elementRef;
      }
    });
  };
};
var VirtualizedList = function VirtualizedList(_ref) {
  var renderRow = _ref.renderRow,
    listRef = _ref.listRef,
    onScroll = _ref.onScroll,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var privateListRef = (0,react.useRef)();
  var _useListItemSize = useListItemSize(privateListRef),
    _useListItemSize2 = (0,slicedToArray/* default */.Z)(_useListItemSize, 2),
    getItemSize = _useListItemSize2[0],
    setItemSize = _useListItemSize2[1];
  var itemData = createItemData(renderRow);
  var handleScroll = function handleScroll(size) {
    return function (scrollProps) {
      onScroll == null ? void 0 : onScroll(scrollProps, size);
    };
  };
  var handleItemSizeDefinition = (0,react.useCallback)(function (index, context) {
    if (!Object.prototype.hasOwnProperty.call(props, 'itemSize')) {
      setItemSize(index, context);
    }
  }, []);
  var getListItemIdFromIndex = function getListItemIdFromIndex(index) {
    var _props$itemKey;
    return "liid:".concat((_props$itemKey = props.itemKey(index)) !== null && _props$itemKey !== void 0 ? _props$itemKey : index);
  };
  var getListItemKeyFromIndex = function getListItemKeyFromIndex(index) {
    var _props$itemKey2;
    return "likey:".concat((_props$itemKey2 = props.itemKey(index)) !== null && _props$itemKey2 !== void 0 ? _props$itemKey2 : index);
  };
  var renderOnResize = (0,lodash.debounce)(function (size) {
    return react.createElement(index_esm/* VariableSizeList */.S_, (0,esm_extends/* default */.Z)({
      ref: assignRefTo(listRef, privateListRef),
      itemData: itemData,
      width: size.width,
      height: size.height,
      itemSize: function itemSize(index) {
        var id = getListItemIdFromIndex(index);
        return getItemSize(id, index);
      },
      onScroll: handleScroll(size)
    }, props, {
      itemKey: getListItemKeyFromIndex
    }), function (_ref2) {
      var data = _ref2.data,
        index = _ref2.index,
        style = _ref2.style;
      var key = getListItemIdFromIndex(index);
      return react.createElement("div", {
        style: style,
        key: key
      }, react.createElement(ChatVirtualizedList_VirtualizedListRow, {
        id: key,
        data: data,
        index: index,
        onSetSize: handleItemSizeDefinition,
        windowWidth: size.width
      }));
    });
  }, 10, {
    leading: true,
    trailing: true
  });
  return react.createElement(react_virtualized_auto_sizer_esm/* default */.ZP, null, renderOnResize);
};
VirtualizedList.defaultProps = {
  itemKey: (noop_default()),
  listRef: (noop_default()),
  onScroll: (noop_default())
};
 false ? 0 : void 0;
VirtualizedList.ssr = false;
/* harmony default export */ var ChatVirtualizedList_VirtualizedList = ((0,react.memo)(VirtualizedList));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatVirtualizedList/VirtualizedList.utils.js

var createDummyElement = function createDummyElement(text, time, options) {
  var element = document.createElement('div');
  var textNode = document.createTextNode(text);
  var spanTimeElement = document.createElement('span');
  spanTimeElement.style.fontSize = '0.750rem';
  spanTimeElement.style["float"] = 'right';
  spanTimeElement.appendChild(document.createTextNode(time));
  element.appendChild(textNode);
  element.appendChild(spanTimeElement);
  element.style.fontFamily = options.font;
  element.style.fontSize = options.fontSize;
  element.style.fontWeight = options.fontWeight;
  element.style.lineHeight = options.lineHeight;
  element.style.width = options.width;
  element.style.maxWidth = options.maxWidth;
  element.style.height = 'auto';
  element.style.wordBreak = options.wordBreak;
  element.style.padding = options.padding;
  element.style.position = 'absolute';
  var parentElement = document.createElement('div');
  parentElement.style.position = 'absolute';
  parentElement.style.visibility = 'hidden';
  parentElement.style.left = '-999px';
  parentElement.style.top = '-999px';
  parentElement.style.width = options.width;
  parentElement.appendChild(element);
  document.body.appendChild(parentElement);
  return {
    element: element,
    parentElement: parentElement
  };
};
var destroyElement = function destroyElement(element) {
  document.body.removeChild(element);
};
var getDefault = function getDefault(value, defaultValue) {
  return value || defaultValue;
};
var getDefaultConfig = function getDefaultConfig(options) {
  var defaultOptions = _extends({}, options);
  defaultOptions.fontSize = getDefault(options.fontSize, '1rem');
  defaultOptions.fontWeight = getDefault(options.fontWeight, 'normal');
  defaultOptions.lineHeight = getDefault(options.lineHeight, 'normal');
  defaultOptions.width = getDefault(options.width, 'auto');
  defaultOptions.maxWidth = getDefault(options.maxWidth, 'none');
  defaultOptions.wordBreak = getDefault(options.wordBreak, 'normal');
  defaultOptions.padding = getDefault(options.padding, '0');
  return defaultOptions;
};
var cache = {};
var calculateSize = function calculateSize(text, time) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cacheKey = JSON.stringify({
    options: options,
    text: text
  });
  if (cache[cacheKey]) {
    return cache[cacheKey];
  }
  var _createDummyElement = createDummyElement(text, time, getDefaultConfig(options)),
    element = _createDummyElement.element,
    parentElement = _createDummyElement.parentElement;
  var size = {
    height: element.offsetHeight,
    width: element.offsetWidth
  };
  destroyElement(parentElement);
  cache[cacheKey] = size;
  return size;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatVirtualizedList/index.js


// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(282);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatInfiniteList/InfiniteList.utils.js

var isScrollDown = function isScrollDown(dir) {
  return dir === 'forward';
};
var isScrollUp = function isScrollUp(dir) {
  return dir === 'backward';
};
var SCROLL_OFFSET = 60;
var makeHandleScroll = function makeHandleScroll(props, scrollRef) {
  var loading = props.loading,
    onLoadPreviousItems = props.onLoadPreviousItems,
    onLoadNextItems = props.onLoadNextItems,
    hasPreviousItems = props.hasPreviousItems,
    hasNextItems = props.hasNextItems;
  var onLoadLess = debounce_default()(function () {
    return onLoadPreviousItems == null ? void 0 : onLoadPreviousItems();
  }, 100);
  var onLoadMore = debounce_default()(function () {
    return onLoadNextItems == null ? void 0 : onLoadNextItems();
  }, 100);
  return function (_ref, _ref2) {
    var scrollOffset = _ref.scrollOffset,
      scrollDirection = _ref.scrollDirection;
    var height = _ref2.height;
    if (loading) {
      return;
    }
    var checkStartOfScroll = function checkStartOfScroll() {
      if (hasPreviousItems && isScrollUp(scrollDirection) && scrollRef.current) {
        var startOfScroll = scrollOffset < SCROLL_OFFSET;
        if (startOfScroll) {
          onLoadLess();
        }
      }
    };
    var checkEndOfScroll = function checkEndOfScroll() {
      if (hasNextItems && isScrollDown(scrollDirection) && scrollRef.current) {
        var endOfScroll = scrollRef.current.scrollHeight - height - SCROLL_OFFSET < scrollOffset;
        if (endOfScroll) {
          onLoadMore();
        }
      }
    };
    checkStartOfScroll();
    checkEndOfScroll();
  };
};
/* harmony default export */ var InfiniteList_utils = ({
  makeHandleScroll: makeHandleScroll
});
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatInfiniteList/InfiniteList.js


var InfiniteList_excluded = ["loading", "onLoadPreviousItems", "onLoadNextItems", "hasPreviousItems", "hasNextItems"];




var InfiniteList = function InfiniteList(props) {
  var loading = props.loading,
    onLoadPreviousItems = props.onLoadPreviousItems,
    onLoadNextItems = props.onLoadNextItems,
    hasPreviousItems = props.hasPreviousItems,
    hasNextItems = props.hasNextItems,
    otherProps = (0,objectWithoutProperties/* default */.Z)(props, InfiniteList_excluded);
  var scrollRef = (0,react.useRef)();
  var onScroll = InfiniteList_utils.makeHandleScroll(props, scrollRef);
  return react.createElement(ChatVirtualizedList_VirtualizedList, (0,esm_extends/* default */.Z)({}, otherProps, {
    onScroll: onScroll,
    innerRef: scrollRef
  }));
};
InfiniteList.defaultProps = {
  hasNextItems: undefined,
  hasPreviousItems: undefined,
  loading: undefined,
  onLoadNextItems: undefined,
  onLoadPreviousItems: undefined
};
 false ? 0 : void 0;
InfiniteList.ssr = false;
/* harmony default export */ var ChatInfiniteList_InfiniteList = ((0,react.memo)(InfiniteList));
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatInfiniteList/InfiniteListContainer.style.js


var _templateObject;


var InfiniteListContainer = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    flex: '1 1 auto',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
    position: 'relative',
    width: '100%'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatInfiniteList/index.js



/***/ }),

/***/ 53706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ChatLoading_ChatLoading; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatLoading/ChatLoading.style.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;


var LoadingContainer = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  background-color: #fff;\n  border-radius: 50%;\n  box-shadow: ", ";\n  left: 50%;\n  transform: translateX(-50%);\n  width: 40px;\n  height: 40px;\n  padding: 4px;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), (0,build_esm.themeGet)('boxShadows.1'), function (_ref) {
  var align = _ref.align;
  return align === 'top' && (0,styled_components_browser_esm.css)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 8px;\n    "])));
}, function (_ref2) {
  var align = _ref2.align;
  return align === 'bottom' && (0,styled_components_browser_esm.css)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      bottom: 8px;\n    "])));
}, function (_ref3) {
  var align = _ref3.align;
  return align === 'center' && (0,styled_components_browser_esm.css)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      top: 50%;\n      transform: translate(-50%, -50%);\n    "])));
});
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatLoading/ChatLoading.js




var ChatLoading = function ChatLoading(_ref) {
  var align = _ref.align;
  return react.createElement(LoadingContainer, {
    align: align,
    "data-testid": "chat-loading"
  }, react.createElement(esm/* Icon */.JO$, {
    name: "AnimatedLoading3",
    width: 32,
    height: 32
  }));
};
ChatLoading.defaultProps = {
  align: 'bottom'
};
 false ? 0 : void 0;
/* harmony default export */ var ChatLoading_ChatLoading = (ChatLoading);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatLoading/index.js


/***/ }),

/***/ 52297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MessageChainRoot_MessageChainRoot; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainHeader/MessageChainHeader.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;


var Avatar = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: ", ";\n  width: 48px;\n  height: 48px;\n  color: ", ";\n  text-align: center;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('radii.circle')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getBackgroundColor)('white')(props);
});
var ButtonStyled = styled_components_browser_esm["default"].button(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", "px ", "px;\n  min-width: 0;\n  border-radius: ", ";\n  white-space: nowrap;\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  height: 33px;\n  display: flex;\n  align-items: center;\n  border: ", ";\n\n  label {\n    text-transform: none;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('space.3'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'), function (props) {
  return (props == null ? void 0 : props.follow) ? '#edf8ff' : (0,stereo_ui_styles_build_esm.getBackgroundColor)('white')(props);
}, (0,stereo_ui_styles_build_esm.themeGet)('palette.primary.base'), (0,stereo_ui_styles_build_esm.themeGet)('palette.primary.base'), (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.medium'), function (props) {
  return (props == null ? void 0 : props.follow) ? '0px' : '1px solid';
});
var ContainerRoot = styled_components_browser_esm["default"].header(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  height: 64px;\n  background-color: ", ";\n  align-items: center;\n  justify-content: space-between;\n  padding: ", "px ", "px;\n\n  & span {\n    margin-left: ", "px;\n    font-size: ", "px;\n    font-weight: ", ";\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getBackgroundColor)('white')(props);
}, (0,stereo_ui_styles_build_esm.themeGet)('space.2'), (0,stereo_ui_styles_build_esm.themeGet)('space.3'), (0,stereo_ui_styles_build_esm.themeGet)('space.2'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.3'), (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.medium'));
var GridEnd = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-content: flex-end;\n"])));
var GridStart = styled_components_browser_esm["default"].div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n"])));
var IconStyle = styled_components_browser_esm["default"].div(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-right: 2px;\n  display: flex;\n  align-items: center;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainHeader/MessageChainHeader.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }






var MessageChainHeader = function MessageChainHeader(props) {
  var label = props.label,
    avatarIcon = props.avatarIcon,
    customerFollower = props.customerFollower;
  var _React$useState = react.useState({
      buttonLabel: customerFollower.isFollowing ? 'Seguindo' : 'Seguir',
      isFollowing: customerFollower.isFollowing
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    buttonFollower = _React$useState2[0],
    setButtonFollower = _React$useState2[1];
  var _useChatSetFollowStat = (0,esm.useChatSetFollowStatus)(),
    fetchSetFollower = _useChatSetFollowStat.fetchSetFollower;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleFollowSeller = function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchSetFollower({
              customerId: customerFollower.customerId,
              followSeller: !buttonFollower.isFollowing,
              sellerId: customerFollower.sellerId
            });
          case 2:
            result = _context.sent;
            setButtonFollower({
              buttonLabel: result.isFollowing ? 'Seguindo' : 'Seguir',
              isFollowing: result.isFollowing
            });
            publish('chat-conversation:followSeller:click', {
              isFollowing: result.isFollowing,
              sellerId: customerFollower.sellerId
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleFollowSeller() {
      return _ref.apply(this, arguments);
    };
  }();
  var changeFollowStatus = function changeFollowStatus() {
    return buttonFollower.isFollowing ? react.createElement(build_esm/* Done */.yR2, {
      color: "background.primary",
      width: 20,
      height: 20
    }) : react.createElement(IconStyle, null, react.createElement(build_esm/* Addition */.kjA, {
      color: "background.primary",
      width: 12,
      height: 20
    }));
  };
  return react.createElement(ContainerRoot, {
    "data-testid": "chat-conversation-header-root"
  }, react.createElement(GridStart, null, react.createElement(Avatar, null, react.createElement(build_esm/* Icon */.JO$, {
    name: avatarIcon,
    color: "background.primary",
    width: 48,
    height: 48
  })), react.createElement("span", {
    "data-testid": "chat-conversation-header-title"
  }, label)), react.createElement(GridEnd, null, react.createElement(ButtonStyled, {
    follow: buttonFollower.isFollowing,
    variant: "contained",
    onClick: handleFollowSeller
  }, changeFollowStatus(), buttonFollower.buttonLabel)));
};
 false ? 0 : void 0;
MessageChainHeader.defaultProps = {
  customerFollower: {
    customerId: '',
    isFollowing: false,
    sellerId: ''
  }
};
/* harmony default export */ var MessageChainHeader_MessageChainHeader = (MessageChainHeader);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatInfiniteList/index.js + 8 modules
var ChatInfiniteList = __webpack_require__(65938);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatLoading/index.js + 2 modules
var ChatLoading = __webpack_require__(53706);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/DateMessage.style.js

var DateMessage_style_templateObject;


var DateMessageRoot = styled_components_browser_esm["default"].div(DateMessage_style_templateObject || (DateMessage_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n  gap: ", ";\n  padding: 8px 4px 16px 4px;\n\n  > hr {\n    flex: 1;\n    margin: 0;\n    height: 0px;\n    border-width: 1px 0 0 0;\n    border-color: ", ";\n  }\n\n  > span {\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    background-color: ", ";\n    border-radius: ", ";\n    padding: 4px 16px;\n    flex: none;\n    flex-grow: 0;\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('space.2')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getPaletteColor)('text.white')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.getPaletteColor)('text.white')(props);
}, (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.medium'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2'), (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.tall'), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('colors.gray')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('radii.big')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/DateMessage.js


var _excluded = ["children"];



var getHeight = function getHeight() {
  return 50;
};
var DateMessage = function DateMessage(_ref) {
  var children = _ref.children,
    rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return react.createElement(DateMessageRoot, (0,esm_extends/* default */.Z)({
    "data-testid": "chat-date-message"
  }, rest), react.createElement("hr", null), react.createElement("span", null, children), react.createElement("hr", null));
};
 false ? 0 : void 0;
DateMessage.getHeight = getHeight;
/* harmony default export */ var ChatMessage_DateMessage = (DateMessage);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageForm/MessageForm.style.js

var MessageForm_style_templateObject, MessageForm_style_templateObject2, MessageForm_style_templateObject3, MessageForm_style_templateObject4, MessageForm_style_templateObject5, MessageForm_style_templateObject6;



var RADII_DEFAULT = (0,stereo_ui_styles_build_esm.themeGet)('radii.default');
var TEXTINPUTAREA_MIN_HEIGHT = '64px';
var ErrorIcon = (0,styled_components_browser_esm["default"])('span')(MessageForm_style_templateObject || (MessageForm_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: normal;\n  margin-top: 5px;\n  background: ", ";\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  display: block;\n  text-align: center;\n  font-size: 8px;\n  flex: none;\n  color: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('palette.alert.danger.text')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('palette.alert.danger.base')(props);
});
var Form = (0,styled_components_browser_esm["default"])('form')(MessageForm_style_templateObject2 || (MessageForm_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", "px ", "px ", "px\n    ", "px;\n  box-shadow: ", ";\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.2'), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('boxShadows.4'));
var SubmitButton = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(MessageForm_style_templateObject3 || (MessageForm_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  background-color: ", ";\n  padding: 0;\n  min-width: 48px;\n  height: inherit;\n  min-height: ", ";\n  border-radius: 0px ", " ", " 0px;\n  border: ", "!important;\n  border-left: none !important;\n  :disabled {\n    opacity: 0.7;\n    background-color: ", ";\n    color: ", ";\n    min-height: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n    outline: 1px solid ", ";\n    outline-offset: -3px;\n  }\n  svg {\n    fill: ", ";\n  }\n"])), (0,stereo_ui_styles_build_esm.getTextColor)('primary'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('white'), TEXTINPUTAREA_MIN_HEIGHT, RADII_DEFAULT, RADII_DEFAULT, (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('base'), (0,stereo_ui_styles_build_esm.getTextColor)('gray'), TEXTINPUTAREA_MIN_HEIGHT, (0,stereo_ui_styles_build_esm.getBackgroundColor)('base'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('opacityBlue'), function (props) {
  return (0,stereo_ui_styles_build_esm.getTextColor)(props.disabled ? 'gray' : 'primary')(props);
});
var TextInput = (0,styled_components_browser_esm["default"])(atoms/* Input */.II)(MessageForm_style_templateObject4 || (MessageForm_style_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: ", ";\n  max-height: 20vh;\n  border-radius: ", " 0px 0px ", ";\n  border: ", ";\n  border-right: none;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: ", ";\n  line-height: ", ";\n  flex-grow: 1;\n  padding: ", "px;\n  &:focus {\n    background-color: ", ";\n    outline: 1px solid ", ";\n    outline-offset: -3px;\n  }\n"])), TEXTINPUTAREA_MIN_HEIGHT, RADII_DEFAULT, RADII_DEFAULT, (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.3'), (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.regular'), (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.input'), (0,stereo_ui_styles_build_esm.themeGet)('space.2'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('base'), (0,stereo_ui_styles_build_esm.getBackgroundColor)('opacityBlue'));
var TextInputArea = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC)(MessageForm_style_templateObject5 || (MessageForm_style_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  justify-items: stretch;\n"])));
var TextInputErrorArea = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu)(MessageForm_style_templateObject6 || (MessageForm_style_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 0px 0px ", " ", ";\n  border: ", ";\n  padding: ", "px;\n  margin: 4px 0 0 0;\n  background-color: ", ";\n  border-color: #f1aeb5;\n  display: flex;\n  gap: ", "px;\n"])), RADII_DEFAULT, RADII_DEFAULT, (0,stereo_ui_styles_build_esm.themeGet)('borders.0'), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('palette.alert.danger.base')(props);
}, (0,stereo_ui_styles_build_esm.themeGet)('space.1'));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageForm/textAreaUtils.js

var useTextAreaResize = function useTextAreaResize(_ref) {
  var inputRef = _ref.ref;
  function resizeTextarea() {
    if (inputRef && inputRef.current) {
      var textarea = inputRef.current;
      var minHeight = textarea.clientHeight;
      textarea.style.height = 'inherit';
      var newHeight = Math.max(minHeight, textarea.scrollHeight);
      textarea.style.height = "".concat(newHeight, "px");
    }
  }
  function resetHeightTextarea() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.style.height = 'initial';
    }
  }
  (0,react.useEffect)(resizeTextarea);
  return {
    resetHeightTextarea: resetHeightTextarea,
    resizeTextarea: resizeTextarea
  };
};
var wrapTextareaValueWithNewline = function wrapTextareaValueWithNewline(event) {
  var str = event.target.value;
  var posicao = event.target.selectionStart;
  return "".concat(str.slice(0, posicao), "\n").concat(str.slice(posicao));
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageForm/useMessageForm.js



var useMessageForm = function useMessageForm(_ref) {
  var handleOnSubmitProp = _ref.handleOnSubmit,
    inputRef = _ref.inputRef;
  var _useState = (0,react.useState)(''),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useTextAreaResize = useTextAreaResize({
      ref: inputRef
    }),
    resetHeightTextarea = _useTextAreaResize.resetHeightTextarea;
  var isValid = (0,react.useMemo)(function () {
    return inputValue.trim().length > 0 && inputValue.match(/^[^a-zA-Z0-9]+$/) === null;
  }, [inputValue]);
  function handleKeyPressEvent(event) {
    if (event.code === 'Enter' && event.shiftKey || event.code === 'Enter' && event.ctrlKey) {
      event.preventDefault();
      var compiledValue = wrapTextareaValueWithNewline(event);
      setInputValue(compiledValue);
    }
  }
  function handleChangeEvent(event) {
    setInputValue(event.target.value);
  }
  var handleSubmitEvent = function handleSubmitEvent(event) {
    event.preventDefault();
    if (isValid) {
      handleOnSubmitProp({
        message: inputValue.trim(),
        ref: {
          resetForm: function resetForm() {
            setInputValue('');
          }
        }
      });
      inputRef.current.focus();
      resetHeightTextarea();
    }
  };
  function handleKeyDownEvent(event) {
    if (event.code === 'Enter' && !event.shiftKey && event.code === 'Enter' && !event.ctrlKey) {
      handleSubmitEvent(event);
    }
  }
  return {
    handleChangeEvent: handleChangeEvent,
    handleKeyDownEvent: handleKeyDownEvent,
    handleKeyPressEvent: handleKeyPressEvent,
    handleSubmitEvent: handleSubmitEvent,
    isValid: isValid,
    value: inputValue
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageForm/MessageForm.js






var MessageForm = function MessageForm(_ref) {
  var onSubmit = _ref.onSubmit,
    loading = _ref.loading,
    error = _ref.error;
  var inputRef = (0,react.useRef)();
  var _useMessageForm = useMessageForm({
      handleOnSubmit: onSubmit,
      inputRef: inputRef
    }),
    handleChangeEvent = _useMessageForm.handleChangeEvent,
    handleSubmitEvent = _useMessageForm.handleSubmitEvent,
    handleKeyDownEvent = _useMessageForm.handleKeyDownEvent,
    handleKeyPressEvent = _useMessageForm.handleKeyPressEvent,
    isValid = _useMessageForm.isValid,
    value = _useMessageForm.value;
  var submitButtonIcon = (0,react.useMemo)(function () {
    return loading ? 'AnimatedLoading3' : 'Send';
  }, [loading]);
  return react.createElement(Form, {
    onSubmit: handleSubmitEvent,
    "aria-keyshortcuts": "Enter"
  }, react.createElement(TextInputArea, null, react.createElement(TextInput, {
    style: {
      borderBottomLeftRadius: error ? 0 : '6px'
    },
    "aria-required": "true",
    "aria-errormessage": "message-form-error",
    "aria-invalid": isValid === false,
    value: value,
    ref: inputRef,
    onKeyPress: handleKeyPressEvent,
    onKeyDown: handleKeyDownEvent,
    onChange: handleChangeEvent,
    multiline: true,
    rows: 1,
    fullWidth: true,
    autocomplete: "off",
    tabindex: 0,
    spellcheck: "true",
    placeholder: "Digite uma mensagem..."
  }), react.createElement(SubmitButton, {
    style: {
      borderBottomRightRadius: error ? 0 : '6px !important'
    },
    "aria-label": "Enviar mensagem",
    type: "submit",
    tabindex: 0,
    disabled: !isValid,
    outline: true,
    centered: true,
    variant: "contained",
    color: "default",
    size: "large"
  }, react.createElement(build_esm/* Icon */.JO$, {
    name: submitButtonIcon,
    "data-icon-name": submitButtonIcon,
    width: 32,
    height: 32
  }))), react.createElement(TextInputErrorArea, {
    bg: "alerts.danger-base",
    style: {
      display: error ? 'flex' : 'none'
    }
  }, react.createElement(ErrorIcon, {
    color: "error",
    fontSize: "1",
    fontWeight: "bold",
    "data-testid": "error-icon"
  }, "!"), react.createElement(atoms/* Text */.xv, {
    "aria-label": error,
    color: "error",
    id: "message-form-error",
    fontSize: "1",
    lineHeight: "150%",
    role: "alert",
    ml: "1"
  }, error)));
};
MessageForm.defaultProps = {
  error: '',
  loading: false
};
 false ? 0 : void 0;

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageForm/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageChain.style.js

var MessageChain_style_templateObject, MessageChain_style_templateObject2;



var ListItem = styled_components_browser_esm["default"].li(MessageChain_style_templateObject || (MessageChain_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"])), (0,stereo_ui_styles_build_esm.getBackgroundColor)('opacityBlue'));
var Root = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC)(MessageChain_style_templateObject2 || (MessageChain_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/useInfiniteList.js


var LAST_INDEX = 99999;
var getScrollToIndex = function getScrollToIndex(messages, lastItemData) {
  var _lastItemData$lastIte;
  var currentLength = messages.length;
  if (currentLength === 0) {
    return -1;
  }
  var diffItems = currentLength - lastItemData.itemCount;
  if (diffItems === 0) {
    return -1;
  }
  var lastItem = messages[currentLength - 1];
  var isScrollingToUp = lastItem.id === ((_lastItemData$lastIte = lastItemData.lastItem) == null ? void 0 : _lastItemData$lastIte.id);
  return isScrollingToUp ? diffItems : LAST_INDEX;
};
var useInfiniteList = function useInfiniteList(_ref) {
  var messages = _ref.messages;
  var itemCount = messages.length;
  var mount = (0,react.useRef)(false);
  var listRef = (0,react.useRef)(null);
  var lastItemData = (0,react.useRef)({
    itemCount: 0
  });
  var _useState = (0,react.useState)({
      index: 0
    }),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    scrollTo = _useState2[0],
    setScrollTo = _useState2[1];
  (0,react.useLayoutEffect)(function () {
    if (listRef.current) {
      var listItemIndexTarget = getScrollToIndex(messages, lastItemData.current);
      if (listItemIndexTarget > 1) {
        listRef.current.resetAfterIndex(0, true);
        setScrollTo({
          index: listItemIndexTarget
        });
      }
    }
    return function () {
      lastItemData.current = {
        itemCount: itemCount,
        lastItem: messages[itemCount - 1]
      };
    };
  }, [messages, listRef, itemCount]);
  (0,react.useLayoutEffect)(function () {
    var _listRef$current;
    listRef == null ? void 0 : (_listRef$current = listRef.current) == null ? void 0 : _listRef$current.scrollToItem(scrollTo.index, 'start');
  }, [listRef, scrollTo]);
  var setInfiniteListRef = function setInfiniteListRef(ref) {
    listRef.current = ref;
    if (mount.current === false && ref) {
      mount.current = true;
      ref.scrollToItem(LAST_INDEX);
    }
    return ref;
  };
  return {
    setInfiniteListRef: setInfiniteListRef
  };
};
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/lodash/uniqueId.js
var uniqueId = __webpack_require__(74930);
var uniqueId_default = /*#__PURE__*/__webpack_require__.n(uniqueId);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/MessageText.js



var MessageText = function MessageText(_ref) {
  var text = _ref.text;
  var urls = text.match(/https?:\/\/\S+/g);
  if (!urls) {
    return text;
  }
  return text.split(/(https?:\/\/\S+)/g).map(function (url) {
    if (urls.includes(url)) {
      return react.createElement("a", {
        "data-testid": "chat-message-link",
        className: "chat-message-link",
        key: uniqueId_default()('chat-message-link-'),
        href: url,
        rel: "noopener noreferrer"
      }, url);
    }
    return url;
  });
};
MessageText.defaultProps = {
  text: ''
};
 false ? 0 : void 0;
/* harmony default export */ var ChatMessage_MessageText = ((0,react.memo)(MessageText));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/variants.js
var PALETTE_TOKENS = {
  alertDangerBase: 'palette.alert.danger.base',
  gray: 'colors.gray',
  textAttributeLabel: 'palette.text.attributeLabel',
  textWhite: 'palette.text.white'
};
var CARD_ALIGNMENT = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end'
};
var CARD_PALETTE = {
  alert: {
    background: PALETTE_TOKENS.alertDangerBase,
    text: PALETTE_TOKENS.textAttributeLabel
  },
  error: {
    background: PALETTE_TOKENS.alertDangerBase,
    text: PALETTE_TOKENS.textAttributeLabel
  },
  gray: {
    background: PALETTE_TOKENS.gray,
    text: PALETTE_TOKENS.textWhite
  },
  primary: {
    background: 'palette.primary.base',
    text: PALETTE_TOKENS.textWhite
  },
  secondary: {
    background: 'palette.background.lighter',
    text: PALETTE_TOKENS.textAttributeLabel
  }
};
var CORNER_SNAP_STYLE = {
  center: '8px',
  left: '8px 8px 8px 0',
  right: '8px 8px 0 8px'
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/styleVariantUtils.js


var getAlignment = function getAlignment(props) {
  return CARD_ALIGNMENT[props.alignment];
};
var getBackgroundColor = function getBackgroundColor(props) {
  if (props.palette in CARD_PALETTE) {
    return (0,stereo_ui_styles_build_esm.themeGet)(CARD_PALETTE[props.palette].background)(props);
  }
  return 'inherit';
};
var getCornerSnapStyleFromCardPosition = function getCornerSnapStyleFromCardPosition(props) {
  return CORNER_SNAP_STYLE[props.alignment];
};
var getTextColor = function getTextColor(props) {
  if (props.palette in CARD_PALETTE) {
    return (0,stereo_ui_styles_build_esm.themeGet)(CARD_PALETTE[props.palette].text)(props);
  }
  return 'inherit';
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/Message.style.js


var Message_style_templateObject, Message_style_templateObject2, Message_style_templateObject3, Message_style_templateObject4;




var MessageContent = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    backgroundColor: getBackgroundColor(props),
    borderRadius: getCornerSnapStyleFromCardPosition(props),
    boxShadow: "4",
    color: getTextColor(props),
    fontSize: 2,
    lineHeight: (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.big')(props),
    maxWidth: '80%',
    padding: 2,
    wordWrap: 'break-word'
  }, props);
})(Message_style_templateObject || (Message_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  .chat-message-link {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), getTextColor);
var MessageContentRaw = styled_components_browser_esm["default"].span.attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(Message_style_templateObject2 || (Message_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  word-wrap: break-word;\n  white-space: break-spaces;\n  line-height: 2;\n  text-indent: 2ch;\n  text-rendering: optimizeLegibility;\n  font-size: ", "px;\n  text-align: justify;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2'));
var MessageRoot = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    flexDirection: 'column',
    paddingX: 3,
    paddingY: 2
  }, props);
})(Message_style_templateObject3 || (Message_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: ", ";\n"])), function (props) {
  return getAlignment(props);
});
var MessageTime = (0,styled_components_browser_esm["default"])('time').attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(Message_style_templateObject4 || (Message_style_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  float: right;\n  padding-top: 16px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.0'));
var MessageTimePlaceholder = (0,styled_components_browser_esm["default"])('sub')({
  flex: 1,
  visibility: 'hidden'
});
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/utils.js
var intlTimeFormat = new Intl.DateTimeFormat('pt-BR', {
  timeStyle: 'short'
});
var createDateFormat = function createDateFormat(timestamp) {
  try {
    if (timestamp) {
      var dateInstance = new Date(timestamp);
      return {
        asIsoString: timestamp,
        asTime: intlTimeFormat.format(dateInstance)
      };
    }
  } catch (_unused) {
    return null;
  }
  return null;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/Message.js


var Message_excluded = ["timestamp", "renderCaption", "children", "alignment", "palette"];






var Message = function Message(_ref) {
  var timestamp = _ref.timestamp,
    renderCaption = _ref.renderCaption,
    children = _ref.children,
    alignment = _ref.alignment,
    palette = _ref.palette,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, Message_excluded);
  var timestampParts = (0,react.useMemo)(function () {
    return createDateFormat(timestamp);
  }, [timestamp]);
  return react.createElement(MessageRoot, (0,esm_extends/* default */.Z)({
    "data-testid": "chat-message-root",
    alignment: alignment
  }, props), react.createElement(MessageContent, {
    palette: palette,
    alignment: alignment,
    "data-testid": "chat-message-content"
  }, react.createElement(MessageContentRaw, null, typeof children === 'string' ? react.createElement(ChatMessage_MessageText, {
    text: children
  }) : children), timestampParts && react.createElement(react.Fragment, null, react.createElement(MessageTimePlaceholder, {
    "aria-hidden": "true"
  }, timestampParts.asTime), react.createElement(MessageTime, {
    "data-testid": "chat-message-time",
    "aria-label": "Hora da mensagem: ".concat(timestampParts.asTime),
    title: "Hora da mensagem: ".concat(timestampParts.asTime),
    dateTime: timestampParts.asIsoString
  }, timestampParts.asTime))), renderCaption && react.createElement(atoms/* Box */.xu, {
    py: 2
  }, renderCaption));
};
Message.defaultProps = {
  children: '',
  renderCaption: null,
  timestamp: ''
};
 false ? 0 : void 0;
/* harmony default export */ var ChatMessage_Message = ((0,react.memo)(Message));
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 6 modules
var organisms = __webpack_require__(28167);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/ProductMessage.style.js

var ProductMessage_style_templateObject;


var ProductMessageRoot = styled_components_browser_esm["default"].div(ProductMessage_style_templateObject || (ProductMessage_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  overflow: hidden;\n  padding: 16px;\n  margin: auto;\n\n  @media only screen and (min-width: 720px) {\n    max-width: 70%;\n  }\n\n  @media only screen and (min-width: 1024px) {\n    max-width: 40%;\n  }\n\n  & > a {\n    box-shadow: ", ";\n    border-radius: ", ";\n    align-items: center;\n    padding: 8px 16px;\n\n    div > img {\n      max-height: 83px;\n    }\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getPaletteColor)('white')(props);
}, (0,stereo_ui_styles_build_esm.themeGet)('boxShadows.4'), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('radii.default')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/ProductMessage.js




var emptyRating = {
  count: 0,
  score: 0
};
var ProductMessage_getHeight = function getHeight() {
  return 119;
};
var ProductMessage = function ProductMessage(_ref) {
  var image = _ref.image,
    price = _ref.price,
    title = _ref.title,
    url = _ref.url;
  return react.createElement(ProductMessageRoot, {
    "data-testid": "chat-message-product"
  }, react.createElement(organisms/* ProductCard */.Il, {
    displayMode: "list",
    installment: {
      amount: price,
      paymentMethodDescription: '',
      quantity: '0',
      totalAmount: price
    },
    title: title,
    image: image,
    rating: emptyRating,
    url: url,
    allowEmptyRating: false,
    hidePrice: true,
    hidePriceMode: "hide"
  }));
};
 false ? 0 : void 0;
ProductMessage.getHeight = ProductMessage_getHeight;
/* harmony default export */ var ChatMessage_ProductMessage = (ProductMessage);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/MessageCaption.js

var MessageCaption_excluded = ["children", "icon"];




var MessageCaption = function MessageCaption(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    rest = (0,objectWithoutProperties/* default */.Z)(_ref, MessageCaption_excluded);
  return react.createElement(atoms/* Flex */.kC, rest, icon && react.createElement(atoms/* Box */.xu, {
    p: "0 4px"
  }, react.createElement(build_esm/* Icon */.JO$, {
    name: icon.key,
    color: icon.color,
    width: 16,
    height: 16
  })), react.createElement(atoms/* Box */.xu, null, children));
};
MessageCaption.defaultProps = {
  icon: {
    color: 'text.primary'
  }
};
 false ? 0 : void 0;
/* harmony default export */ var ChatMessage_MessageCaption = (MessageCaption);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/CouponMessage.style.js

var CouponMessage_style_templateObject, CouponMessage_style_templateObject2, CouponMessage_style_templateObject3;




var CouponMessage_style_ButtonStyled = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(CouponMessage_style_templateObject || (CouponMessage_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-left: ", "px;\n  padding: ", "px ", "px;\n  min-width: 0;\n  border-radius: ", ";\n  white-space: nowrap;\n\n  label {\n    font-size: ", "px;\n    text-transform: none !important;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.2'), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('space.3'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2'));
var MessageCouponCodeContainer = styled_components_browser_esm["default"].span(CouponMessage_style_templateObject2 || (CouponMessage_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ", ";\n  border-style: dashed;\n  border-radius: ", ";\n  padding: ", "px ", "px;\n  white-space: nowrap;\n"])), (0,stereo_ui_styles_build_esm.getPaletteColor)('border.base'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('space.3'));
var MessageCouponContent = (0,styled_components_browser_esm["default"])(MessageContent)(CouponMessage_style_templateObject3 || (CouponMessage_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n"])));

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/CouponMessage.js


var CouponMessage_excluded = ["alignment", "children", "couponCode", "palette"];




var CouponMessage = function CouponMessage(_ref) {
  var alignment = _ref.alignment,
    children = _ref.children,
    couponCode = _ref.couponCode,
    palette = _ref.palette,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, CouponMessage_excluded);
  var onClick = function onClick() {
    navigator.clipboard.writeText(couponCode);
  };
  return react.createElement(react.Fragment, null, react.createElement(ChatMessage_Message, (0,esm_extends/* default */.Z)({
    alignment: alignment,
    palette: palette
  }, props), children), react.createElement(MessageRoot, (0,esm_extends/* default */.Z)({
    "data-testid": "chat-message-root",
    alignment: alignment
  }, props), react.createElement(MessageCouponContent, {
    palette: palette,
    alignment: alignment
  }, react.createElement(MessageCouponCodeContainer, null, couponCode), react.createElement(CouponMessage_style_ButtonStyled, {
    color: "primary",
    variant: "contained",
    onClick: onClick
  }, "Copiar c\xF3digo"))));
};
CouponMessage.defaultProps = {
  children: '',
  renderCaption: null,
  timestamp: ''
};
 false ? 0 : void 0;
/* harmony default export */ var ChatMessage_CouponMessage = ((0,react.memo)(CouponMessage));
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/CustomMessage.style.js

var CustomMessage_style_templateObject, CustomMessage_style_templateObject2;




var CustomMessage_style_ButtonStyled = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(CustomMessage_style_templateObject || (CustomMessage_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", "px ", "px;\n  min-width: 0;\n  border-radius: ", ";\n  white-space: nowrap;\n\n  label {\n    font-size: ", "px;\n    text-transform: none !important;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.1'), (0,stereo_ui_styles_build_esm.themeGet)('space.3'), (0,stereo_ui_styles_build_esm.themeGet)('radii.default'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2'));
var MessageCustomContent = (0,styled_components_browser_esm["default"])(MessageContent)(CustomMessage_style_templateObject2 || (CustomMessage_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n"])));

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/CustomMessage.js


var CustomMessage_excluded = ["alignment", "btnTitle", "children", "deepLink", "palette"];





var CustomMessage = function CustomMessage(_ref) {
  var alignment = _ref.alignment,
    btnTitle = _ref.btnTitle,
    children = _ref.children,
    deepLink = _ref.deepLink,
    palette = _ref.palette,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, CustomMessage_excluded);
  return react.createElement(react.Fragment, null, react.createElement(ChatMessage_Message, (0,esm_extends/* default */.Z)({
    alignment: alignment,
    palette: palette
  }, props), children), deepLink && react.createElement(MessageRoot, (0,esm_extends/* default */.Z)({
    "data-testid": "chat-message-root",
    alignment: alignment
  }, props), react.createElement(MessageCustomContent, {
    palette: palette,
    alignment: alignment
  }, react.createElement(Link/* default */.Z, {
    href: deepLink,
    target: "_blank",
    underline: false
  }, btnTitle && react.createElement(CustomMessage_style_ButtonStyled, {
    color: "primary",
    variant: "contained"
  }, btnTitle)))));
};
CustomMessage.defaultProps = {
  btnTitle: '',
  children: '',
  deepLink: null,
  renderCaption: null,
  timestamp: ''
};
 false ? 0 : void 0;
/* harmony default export */ var ChatMessage_CustomMessage = ((0,react.memo)(CustomMessage));
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/ModerationReadMoreLink/ModerationReadMoreLink.style.js

var ModerationReadMoreLink_style_templateObject, ModerationReadMoreLink_style_templateObject2, ModerationReadMoreLink_style_templateObject3;



var DialogContainer = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu)(ModerationReadMoreLink_style_templateObject || (ModerationReadMoreLink_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > div:first-child {\n    padding-bottom: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n"])));
var List = styled_components_browser_esm["default"].ul(ModerationReadMoreLink_style_templateObject2 || (ModerationReadMoreLink_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  list-style: disc;\n  padding-left: ", "px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.3'));
var ModerationReadMoreLink_style_ListItem = styled_components_browser_esm["default"].li(ModerationReadMoreLink_style_templateObject3 || (ModerationReadMoreLink_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: ", "px 0;\n  line-height: ", ";\n  font-size: ", "px;\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.3'), (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.big'), (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.2'));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/ModerationReadMoreLink/ModerationReadMoreLink.js






var ModerationReadMoreLink = function ModerationReadMoreLink(_ref) {
  var label = _ref.label;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClick = function handleClick() {
    setOpen(function (prevValue) {
      return !prevValue;
    });
  };
  return react.createElement(react.Fragment, null, react.createElement(atoms/* Link */.rU, {
    color: "text.primary",
    onClick: handleClick
  }, label), (0,react_dom.createPortal)(react.createElement(DialogContainer, null, react.createElement(atoms/* Dialog */.Vq, {
    bg: "background.white",
    type: "dialog",
    position: "bottom",
    showClose: true,
    fullScreen: true,
    visible: open,
    onClickOutside: handleClick
  }, react.createElement(atoms/* Box */.xu, {
    p: "2",
    "data-testid": "Dialog-Container"
  }, react.createElement(atoms/* Text */.xv, {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 4
  }, "Regulamento Aprova\xE7\xE3o/Reprova\xE7\xE3o"), react.createElement(atoms/* Text */.xv, {
    textAlign: "center",
    color: "primary",
    fontSize: 3,
    mb: 4,
    mt: 4
  }, "Chat com lojista Magalu"), react.createElement(atoms/* Text */.xv, {
    lineHeight: "big",
    fontSize: 2
  }, "Para garantir a seguran\xE7a e qualidade da informa\xE7\xE3o, todas as mensagens passam por valida\xE7\xE3o."), react.createElement(atoms/* Text */.xv, {
    color: "primary",
    fontSize: 2,
    mb: 3,
    mt: 3
  }, "N\xE3o \xE9 permitido"), react.createElement(List, null, react.createElement(ModerationReadMoreLink_style_ListItem, null, "Troca de informa\xE7\xF5es de contatos diretos (CPF, n\xFAmero de telefone, e-mail, perfis em redes sociais e/ou endere\xE7o);"), react.createElement(ModerationReadMoreLink_style_ListItem, null, "Conte\xFAdo ofensivo, preconceituoso e discriminat\xF3rio de qualquer natureza ou que ofendam a imagem do Magalu;"), react.createElement(ModerationReadMoreLink_style_ListItem, null, "Enviar mensagens com informa\xE7\xF5es de pagamento;")), react.createElement(atoms/* Text */.xv, {
    color: "primary",
    fontSize: 2,
    mb: 3,
    mt: 3
  }, "Recomendamos"), react.createElement(List, null, react.createElement(ModerationReadMoreLink_style_ListItem, null, "Compartilhamento de produtos apenas do site magazineluiza.com.br;"), react.createElement(ModerationReadMoreLink_style_ListItem, null, "Caso tenha recebido informa\xE7\xE3o de mensagem bloqueada, analise os crit\xE9rios acima e envie novamente."))))), document.body));
};
 false ? 0 : void 0;
/* harmony default export */ var ModerationReadMoreLink_ModerationReadMoreLink = ((0,react.memo)(ModerationReadMoreLink));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/ModerationReadMoreLink/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/constants.js
var MODERATION_MESSAGE_RESULT = {
  NOT_MODERATED: 'Mensagem em análise para aprovação.',
  REJECTED: 'Mensagem bloqueada por conter dados sensíveis.',
  WAITING_MODERATION: 'Mensagem em análise para aprovação.'
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessage/index.js









;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/SubMessageAction.js





var SubMessageAction = function SubMessageAction(_ref) {
  var label = _ref.label,
    type = _ref.type,
    onClick = _ref.onClick;
  if (type === 'readmore') {
    return react.createElement(ModerationReadMoreLink_ModerationReadMoreLink, {
      label: label
    });
  }
  if (type === 'generic') {
    return (react.createElement(atoms/* Link */.rU, {
        color: "text.primary",
        onClick: onClick
      }, label)
    );
  }
  return null;
};
SubMessageAction.defaultProps = {
  onClick: lodash.noop
};
 false ? 0 : void 0;
/* harmony default export */ var ChatMessageChain_SubMessageAction = ((0,react.memo)(SubMessageAction));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/constants.js
var CUSTOM_FIELD_DEEP_LINK_PREFIX = 'deepLink';
var CUSTOM_MESSAGES_WITH_DEEP_LINKS = {
  REPURCHASE: {
    btnTitle: 'Comprar',
    deepLinkId: 'deepLinkPDP'
  },
  REVIEW: {
    btnTitle: 'Avaliar Produto',
    deepLinkId: 'deepLinkReview'
  }
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/RenderRow.js







var RenderRow = function RenderRow(_ref) {
  var id = _ref.id,
    alignment = _ref.alignment,
    timestamp = _ref.timestamp,
    palette = _ref.palette,
    contentCaption = _ref.contentCaption,
    content = _ref.content,
    customFields = _ref.customFields;
  var rendererMessageCaption = function rendererMessageCaption(captionProps) {
    if (captionProps && captionProps.text) {
      return react.createElement(ChatMessage_MessageCaption, {
        icon: captionProps.iconId
      }, react.createElement(Text/* default */.Z, {
        fontSize: 0
      }, captionProps.text), (captionProps == null ? void 0 : captionProps.clickAction) && react.createElement(ChatMessageChain_SubMessageAction, {
        label: captionProps.clickAction.label,
        type: captionProps.clickAction.type,
        onClick: captionProps.clickAction.onClick
      }));
    }
    return null;
  };
  var getCustomMessageButtomByDeepLinkId = function getCustomMessageButtomByDeepLinkId() {
    var customFieldsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var deepLinkIdCustomField = Object.keys(customFieldsObj).find(function (key) {
      return key.startsWith(CUSTOM_FIELD_DEEP_LINK_PREFIX);
    });
    if (deepLinkIdCustomField) {
      var customMessageConfiguration = Object.values(CUSTOM_MESSAGES_WITH_DEEP_LINKS).find(function (message) {
        return message.deepLinkId === deepLinkIdCustomField;
      });
      return customMessageConfiguration || null;
    }
    return null;
  };
  var renderContent = function renderContent() {
    if (customFields && customFields.promoCouponCode) {
      return react.createElement(ChatMessage_CouponMessage, {
        alignment: alignment,
        timestamp: timestamp,
        palette: palette,
        renderCaption: rendererMessageCaption(contentCaption),
        couponCode: customFields.promoCouponCode
      }, content);
    }
    if (customFields && palette !== 'product') {
      var deepLinkCustomMessage = getCustomMessageButtomByDeepLinkId(customFields);
      return react.createElement(ChatMessage_CustomMessage, {
        alignment: alignment,
        btnTitle: deepLinkCustomMessage == null ? void 0 : deepLinkCustomMessage.btnTitle,
        deepLink: customFields && customFields[deepLinkCustomMessage == null ? void 0 : deepLinkCustomMessage.deepLinkId],
        timestamp: timestamp,
        palette: palette,
        renderCaption: rendererMessageCaption(contentCaption)
      }, content);
    }
    if (palette === 'product' && customFields) {
      return react.createElement(ChatMessage_ProductMessage, {
        image: customFields.productImage,
        title: customFields.productTitle,
        url: customFields.productUrl
      });
    }
    return react.createElement(ChatMessage_Message, {
      alignment: alignment,
      timestamp: timestamp,
      palette: palette,
      renderCaption: rendererMessageCaption(contentCaption)
    }, content);
  };
  return react.createElement(ListItem, {
    tabIndex: 0,
    key: id,
    "data-testid": "chat-message-chain-node"
  }, renderContent());
};
RenderRow.defaultProps = {
  contentCaption: null,
  customFields: undefined,
  timestamp: ''
};
 false ? 0 : void 0;
/* harmony default export */ var MessageChain_RenderRow = ((0,react.memo)(RenderRow));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/utils.js
function isValidISODate(str) {
  return !Number.isNaN(Date.parse(str));
}
var intlDateFormat = new Intl.DateTimeFormat('pt-BR', {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
});
function createItemMapWithDateHeader(messages) {
  var resultMap = new Map();
  var lastFormattedDate;
  messages == null ? void 0 : messages.forEach(function (message) {
    if (!isValidISODate(message.timestamp)) return;
    var date = intlDateFormat.format(new Date(message.timestamp));
    if (lastFormattedDate === undefined || lastFormattedDate !== date) {
      resultMap.set(message.id, {
        dateAsFormatPtBr: date
      });
      lastFormattedDate = date;
    }
  });
  return resultMap;
}
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChain/MessageChain.js


var MessageChain_excluded = ["customerFollower", "infiniteListProps", "messages", "postMessage", "store"],
  _excluded2 = ["hasNextItems", "loading", "onFetchMore"];












var MessageChain = function MessageChain(props) {
  var customerFollower = props.customerFollower,
    infiniteListProps = props.infiniteListProps,
    messages = props.messages,
    postMessage = props.postMessage,
    store = props.store,
    rest = (0,objectWithoutProperties/* default */.Z)(props, MessageChain_excluded);
  var hasNextItems = infiniteListProps.hasNextItems,
    loading = infiniteListProps.loading,
    onFetchMore = infiniteListProps.onFetchMore,
    restInfiniteListProps = (0,objectWithoutProperties/* default */.Z)(infiniteListProps, _excluded2);
  var _useInfiniteList = useInfiniteList({
      messages: messages
    }),
    setInfiniteListRef = _useInfiniteList.setInfiniteListRef,
    onItemsRendered = _useInfiniteList.onItemsRendered;
  var dateMap = (0,react.useRef)(new Map());
  dateMap.current = (0,react.useMemo)(function () {
    return createItemMapWithDateHeader(messages);
  }, [messages.length]);
  var renderRow = (0,react.useCallback)(function (index) {
    var messageProps = messages[index];
    var messageId = messageProps.id;
    if (dateMap.current.has(messageId)) {
      var _dateMap$current$get = dateMap.current.get(messageId),
        dateAsFormatPtBr = _dateMap$current$get.dateAsFormatPtBr;
      return react.createElement(react.Fragment, null, react.createElement(ChatMessage_DateMessage, {
        tabIndex: 0
      }, react.createElement("time", {
        dateTime: messageProps.timestamp,
        "aria-label": "Data das mensagens: ".concat(dateAsFormatPtBr)
      }, dateAsFormatPtBr)), react.createElement(MessageChain_RenderRow, messageProps));
    }
    return react.createElement(MessageChain_RenderRow, messageProps);
  }, [messages]);
  var subjectOfConversation = "Chat com ".concat(store.description, " .");
  return react.createElement(Root, (0,esm_extends/* default */.Z)({
    flexDirection: "column",
    "data-testid": "chat-message-chain-root"
  }, rest), react.createElement(MessageChainHeader_MessageChainHeader, {
    label: store.description,
    avatarIcon: "SellerStore",
    customerFollower: customerFollower
  }), loading && react.createElement(ChatLoading/* default */.Z, {
    align: "top"
  }), react.createElement(ChatInfiniteList/* InfiniteListContainer */.L, {
    "data-testid": "chat-conversation-list",
    bg: "background.base"
  }, react.createElement(ChatInfiniteList/* InfiniteList */.$, (0,esm_extends/* default */.Z)({
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-label": subjectOfConversation,
    innerTagName: "ol",
    listRef: setInfiniteListRef,
    itemCount: messages.length,
    renderRow: renderRow,
    onLoadPreviousItems: onFetchMore,
    hasPreviousItems: hasNextItems,
    loading: loading,
    onItemsRendered: onItemsRendered
  }, restInfiniteListProps))), react.createElement(MessageForm, {
    onSubmit: postMessage.onSubmit,
    loading: postMessage.loading,
    error: postMessage.error
  }));
};
MessageChain.defaultProps = {
  customerFollower: {
    customerId: '',
    isFollowing: false,
    sellerId: ''
  },
  infiniteListProps: {
    hasNextItems: false,
    loading: false,
    overscanCount: 20
  },
  postMessage: {
    error: null,
    loading: false,
    onSubmit: lodash.noop
  },
  store: {
    description: ''
  }
};
 false ? 0 : void 0;
/* harmony default export */ var MessageChain_MessageChain = ((0,react.memo)(MessageChain));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/renderUtils.js


var createComplexContentElement = function createComplexContentElement(message) {
  if (Array.isArray(message == null ? void 0 : message.content)) {
    var rows = message.content.map(function (data, index) {
      return {
        data: data,
        key: index
      };
    });
    return rows.map(function (content) {
      var data = content.data,
        key = content.key;
      if (Object.prototype.hasOwnProperty.call(data, 'kind')) {
        if (data.kind === 'link') {
          return react.createElement(ModerationReadMoreLink_ModerationReadMoreLink, {
            key: "message-".concat(message.id, "-").concat(key),
            label: data.label
          });
        }
        return data.value;
      }
      return data;
    });
  }
  return message == null ? void 0 : message.content;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/utils.js




var getCardCaptionIconFromModeration = function getCardCaptionIconFromModeration(message) {
  var iconMapping = {
    NOT_MODERATED: {
      color: 'text.primary',
      key: 'Clock'
    },
    REJECTED: {
      color: 'text.error',
      key: 'SecurityTip'
    },
    WAITING_MODERATION: {
      color: 'text.primary',
      key: 'Clock'
    }
  };
  return iconMapping[message.moderation.status];
};
var getCardPalletColorFromModeration = function getCardPalletColorFromModeration(moderation, senderKind) {
  if (senderKind === 'seller') {
    var mapping = {
      APPROVED: 'secondary',
      NOT_MODERATED: 'secondary',
      REJECTED: 'alert',
      WAITING_MODERATION: 'gray'
    };
    return mapping[moderation.status];
  }
  if (senderKind === 'customer') {
    var _mapping = {
      APPROVED: 'primary',
      NOT_MODERATED: 'primary',
      REJECTED: 'alert',
      WAITING_MODERATION: 'primary'
    };
    return _mapping[moderation.status];
  }
  return 'gray';
};
var getCardAling = function getCardAling(sellerKind) {
  var mapping = {
    customer: 'right',
    seller: 'left',
    system: 'center'
  };
  return mapping[sellerKind] || 'center';
};
var getModerationStatusCaption = function getModerationStatusCaption(message) {
  var _MODERATION_MESSAGE_R;
  return (_MODERATION_MESSAGE_R = MODERATION_MESSAGE_RESULT[message.moderation.status]) !== null && _MODERATION_MESSAGE_R !== void 0 ? _MODERATION_MESSAGE_R : null;
};
var getMessageSender = function getMessageSender(message) {
  return !(message == null ? void 0 : message.fromUser) ? 'seller' : message.fromUser.type;
};
var isProductMessage = function isProductMessage(message) {
  var _message$customFields;
  return !!(message == null ? void 0 : (_message$customFields = message.customFields) == null ? void 0 : _message$customFields.find(function (field) {
    return field.name === 'productId';
  }));
};
var isCouponMessage = function isCouponMessage(message) {
  var _message$customFields2;
  return !!(message == null ? void 0 : (_message$customFields2 = message.customFields) == null ? void 0 : _message$customFields2.find(function (field) {
    return field.name === 'promoCouponCode';
  }));
};
var isCustomMessageWithDeepLink = function isCustomMessageWithDeepLink(message) {
  var _message$customFields3;
  var deepLinksAllowed = Object.values(CUSTOM_MESSAGES_WITH_DEEP_LINKS).map(function (messageAllowed) {
    return messageAllowed.deepLinkId;
  });
  return message == null ? void 0 : (_message$customFields3 = message.customFields) == null ? void 0 : _message$customFields3.some(function (field) {
    return deepLinksAllowed.includes(field.name);
  });
};
var getCustomFields = function getCustomFields(messageData) {
  var _messageData$customFi;
  return messageData == null ? void 0 : (_messageData$customFi = messageData.customFields) == null ? void 0 : _messageData$customFi.reduce(function (acc, current) {
    acc[current.name] = current.value;
    return acc;
  }, {});
};
var createProductMessage = function createProductMessage(messageData) {
  var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var structure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var getProductFields = function getProductFields() {
    var _structure$config;
    return {
      productId: product.id,
      productImage: product.image,
      productTitle: product.title,
      productUrl: "".concat(structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.desktopSiteDomain, "/").concat(product.url)
    };
  };
  return {
    alignment: 'center',
    content: messageData.content,
    customFields: (0,esm_extends/* default */.Z)({}, messageData.id ? getCustomFields(messageData) : getProductFields()),
    id: messageData.id || product.id,
    palette: 'product'
  };
};
var createMessage = function createMessage(messageData) {
  if (!messageData) {
    return messageData;
  }
  if (isProductMessage(messageData)) {
    return createProductMessage(messageData);
  }
  if (isCouponMessage(messageData)) {
    return {
      alignment: 'left',
      content: createComplexContentElement(messageData),
      contentCaption: {
        clickAction: null,
        iconId: null,
        text: null
      },
      customFields: getCustomFields(messageData),
      id: messageData.id,
      palette: 'secondary',
      timestamp: messageData.whenAt
    };
  }
  if (isCustomMessageWithDeepLink(messageData)) {
    return {
      alignment: 'left',
      content: createComplexContentElement(messageData),
      contentCaption: {
        clickAction: null,
        iconId: null,
        text: null
      },
      customFields: getCustomFields(messageData),
      id: messageData.id,
      palette: 'secondary',
      timestamp: messageData.whenAt
    };
  }
  var cardActionClick = null;
  var cardCaptionText = null;
  var cardCaptionIconId = null;
  var cardPaletteColor = null;
  var senderKind = String(getMessageSender(messageData)).toLowerCase();
  switch (senderKind) {
    case 'seller':
      cardPaletteColor = getCardPalletColorFromModeration(messageData.moderation, 'seller');
      cardCaptionText = getModerationStatusCaption(messageData);
      if (cardCaptionText) {
        cardCaptionIconId = getCardCaptionIconFromModeration(messageData);
        cardActionClick = {
          label: 'Saiba mais',
          type: 'readmore'
        };
      }
      break;
    case 'system':
      cardPaletteColor = 'alert';
      break;
    case 'customer':
      cardPaletteColor = getCardPalletColorFromModeration(messageData.moderation, 'customer');
      if (messageData.moderation.status === 'REJECTED') {
        cardCaptionText = MODERATION_MESSAGE_RESULT.REJECTED;
        cardCaptionIconId = getCardCaptionIconFromModeration(messageData);
        cardActionClick = {
          label: 'Saiba mais',
          type: 'readmore'
        };
      }
      break;
    default:
      cardPaletteColor = 'gray';
      break;
  }
  return {
    alignment: getCardAling(senderKind),
    content: createComplexContentElement(messageData),
    contentCaption: cardCaptionText ? {
      clickAction: cardActionClick,
      iconId: cardCaptionIconId,
      text: cardCaptionText
    } : null,
    id: messageData.id,
    palette: cardPaletteColor,
    timestamp: messageData == null ? void 0 : messageData.whenAt
  };
};
var createMessageList = function createMessageList(chatMessageList) {
  if (Array.isArray(chatMessageList)) {
    return chatMessageList.map(function (item) {
      return createMessage(item);
    });
  }
  return [];
};
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatAlternateState/ConnErrorState.js
var ConnErrorState = __webpack_require__(20028);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/MessageChainRoot.utils.js
var adaptUserToSender = function adaptUserToSender(data) {
  if (data) {
    return {
      fullname: data.name,
      id: data.id,
      username: data.email
    };
  }
  return data;
};
var createMessageAsError = function createMessageAsError(_ref) {
  var error = _ref.error,
    message = _ref.message,
    handler = _ref.handler;
  var currentDate = new Date();
  var syntheticId = "chat-message-id-".concat(currentDate.getTime());
  return {
    alignment: 'right',
    content: message,
    contentCaption: {
      clickAction: {
        label: 'Clique aqui para reenviar.',
        onClick: handler,
        type: 'generic'
      },
      iconId: 'SecurityTip',
      text: error
    },
    id: syntheticId,
    palette: 'error',
    timestamp: currentDate.toISOString()
  };
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/useLocalChatStore.js




var useChatLocalStore = function useChatLocalStore(initialValue) {
  var _useState = (0,react.useState)([]),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    localMessages = _useState2[0],
    setLocalMessages = _useState2[1];
  var _useState3 = (0,react.useState)([]),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    remoteMessages = _useState4[0],
    setRemoteMessages = _useState4[1];
  (0,react.useEffect)(function () {
    var messagesList = createMessageList(initialValue);
    var newLocalMessages = localMessages.reduce(function (acc, message) {
      var exists = messagesList.find(function (item) {
        return item.id === message.id;
      });
      if (exists) {
        return acc;
      }
      return [].concat((0,toConsumableArray/* default */.Z)(acc), [message]);
    }, []);
    setLocalMessages(newLocalMessages);
    setRemoteMessages(messagesList);
  }, [JSON.stringify(initialValue)]);
  var removeMessage = (0,react.useCallback)(function (id) {
    setLocalMessages(function (prev) {
      return prev.filter(function (item) {
        return item.id !== id;
      });
    });
  }, [setLocalMessages]);
  var addMessage = (0,react.useCallback)(function (newMessage) {
    setLocalMessages(function (prev) {
      return prev.concat(newMessage);
    });
  }, [setLocalMessages]);
  return {
    addMessage: addMessage,
    messages: remoteMessages.concat(localMessages),
    removeMessage: removeMessage
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/MessageChainRoot.style.js

var MessageChainRoot_style_templateObject;

var MessagesList = styled_components_browser_esm["default"].div(MessageChainRoot_style_templateObject || (MessageChainRoot_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  font-family: 'MagaluTextos', sans-serif;\n  max-width: 1280px;\n  margin: auto;\n  height: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/MessageChainRoot.js





var MessageChainRoot_excluded = ["postMessage"],
  MessageChainRoot_excluded2 = ["result", "fetchMore", "refetch"];
function MessageChainRoot_regeneratorRuntime() { "use strict"; MessageChainRoot_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }












var MessageChainRoot = function MessageChainRoot(_ref) {
  var _result$data, _result$pagination, _result$pagination$li;
  var structure = _ref.structure,
    store = _ref.store,
    product = _ref.product,
    conversation = _ref.conversation,
    onReceiveMessages = _ref.onReceiveMessages,
    staticProps = _ref["static"],
    user = _ref.user;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useChatUserData = (0,hooks/* useChatUserData */.Cv)({
      structure: structure
    }),
    userData = _useChatUserData.data;
  var activeProduct = (0,react.useRef)();
  var _useState = (0,react.useState)(structure.route.conversationId || conversation.id),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    conversationId = _useState2[0],
    setConversationId = _useState2[1];
  var _useChatPostMessage = (0,esm.useChatPostMessage)({
      product: product,
      sender: adaptUserToSender(user),
      staticProps: staticProps,
      structure: structure
    }),
    postMessage = _useChatPostMessage.postMessage,
    messageMutationResponse = (0,objectWithoutProperties/* default */.Z)(_useChatPostMessage, MessageChainRoot_excluded);
  var _useChatMessages = (0,esm.useChatMessages)({
      conversationId: conversationId,
      onReceiveMessages: onReceiveMessages,
      staticProps: staticProps,
      userId: user.id
    }),
    result = _useChatMessages.result,
    fetchMore = _useChatMessages.fetchMore,
    refetch = _useChatMessages.refetch,
    messagesResponse = (0,objectWithoutProperties/* default */.Z)(_useChatMessages, MessageChainRoot_excluded2);
  var _useChatGetLastProduc = (0,esm.useChatGetLastProduct)({
      conversationId: conversationId,
      staticProps: staticProps
    }),
    lastProduct = _useChatGetLastProduc.lastProduct;
  var _useChatIsCustomerFol = (0,esm.useChatIsCustomerFollowingSeller)({
      customerId: user.id,
      sellerId: store.id
    }),
    _useChatIsCustomerFol2 = _useChatIsCustomerFol.resultCustomerFollower,
    customerFollower = _useChatIsCustomerFol2 === void 0 ? {
      customerId: '',
      isFollowing: false,
      sellerId: ''
    } : _useChatIsCustomerFol2;
  var _useChatLocalStore = useChatLocalStore((_result$data = result == null ? void 0 : result.data) !== null && _result$data !== void 0 ? _result$data : []),
    messages = _useChatLocalStore.messages,
    addMessage = _useChatLocalStore.addMessage,
    removeMessage = _useChatLocalStore.removeMessage;
  (0,react.useEffect)(function () {
    if ((result == null ? void 0 : result.data) && product && !activeProduct.current && lastProduct !== product.id) {
      addMessage(createProductMessage({}, product, structure));
      activeProduct.current = product;
    }
  }, [result == null ? void 0 : result.data]);
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    postError = _useState4[0],
    setPostError = _useState4[1];
  var handleOnPostMessage = (0,react.useCallback)(function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(MessageChainRoot_regeneratorRuntime().mark(function _callee(formData, retryId) {
      var postParam, response, messsageAsError;
      return MessageChainRoot_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setPostError(null);
            postParam = {
              content: formData.message
            };
            _context.next = 5;
            return postMessage(store, conversationId, postParam, lastProduct);
          case 5:
            response = _context.sent;
            if (retryId) removeMessage(retryId);
            setConversationId(response.conversationId);
            addMessage(createMessage((0,esm_extends/* default */.Z)({}, response.message, postParam)));
            formData.ref.resetForm();
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            if (!retryId && (_context.t0 == null ? void 0 : _context.t0.allowRetry)) {
              formData.ref.resetForm();
              messsageAsError = createMessageAsError({
                error: 'Houve um erro ao tentar enviar a mensagem.',
                handler: function handler() {
                  handleOnPostMessage(formData, messsageAsError.id);
                },
                message: formData.message
              });
              addMessage(messsageAsError);
            }
            if ((_context.t0 == null ? void 0 : _context.t0.allowRetry) === false) {
              formData.ref.resetForm();
              setPostError(_context.t0.message);
            }
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [postMessage, addMessage, removeMessage]);
  (0,react.useEffect)(function () {
    if (userData) {
      var _structure$cookies, _structure$cookies2;
      publish('sellerchat:conversation:onview', {
        sellerName: store == null ? void 0 : store.description,
        userId: userData.id,
        userIsLogged: userData.isLogged,
        userLocation: (0,esm_extends/* default */.Z)({}, structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.location, {
          zipCode: structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.zipCode
        })
      });
    }
  }, [userData]);
  return react.createElement(MessagesList, {
    "aria-busy": messagesResponse.loading,
    "data-testid": "MessageChainRoot-Root"
  }, messagesResponse.error && react.createElement(ConnErrorState/* default */.Z, {
    onRetry: refetch
  }), messagesResponse.error === null && result && customerFollower && react.createElement(MessageChain_MessageChain, {
    "data-testid": "MessageChain-Root",
    store: store,
    customerFollower: customerFollower,
    messages: messages,
    postMessage: {
      error: postError,
      loading: messageMutationResponse.loading,
      onSubmit: handleOnPostMessage
    },
    infiniteListProps: {
      hasNextItems: !!((_result$pagination = result.pagination) == null ? void 0 : (_result$pagination$li = _result$pagination.links) == null ? void 0 : _result$pagination$li.next),
      itemKey: function itemKey(index) {
        var _messages$index;
        return messages == null ? void 0 : (_messages$index = messages[index]) == null ? void 0 : _messages$index.id;
      },
      loading: messagesResponse.loading,
      onFetchMore: fetchMore
    }
  }));
};
MessageChainRoot.defaultProps = {
  conversation: {},
  onReceiveMessages: function onReceiveMessages() {},
  product: undefined,
  "static": {},
  store: {}
};
 false ? 0 : void 0;
MessageChainRoot.ssr = true;
/* harmony default export */ var MessageChainRoot_MessageChainRoot = ((0,withLayoutProps/* default */.Z)(MessageChainRoot));

/***/ }),

/***/ 82243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ChatProductMessages_ChatProductMessages; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/hooks/index.js + 14 modules
var hooks = __webpack_require__(1001);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/MessageChainRoot.js + 39 modules
var MessageChainRoot = __webpack_require__(52297);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatProductMessages/ChatProductMessages.js







var ChatProductMessages = function ChatProductMessages(_ref) {
  var _data$product, _data$product$offers$, _data$search, _data$search$items, _data$search$items$, _data$search$items$$o, _data$search$items$$o2, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var seller = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$offers$ = _data$product.offers[0]) == null ? void 0 : _data$product$offers$.seller) || (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$items = _data$search.items) == null ? void 0 : (_data$search$items$ = _data$search$items[0]) == null ? void 0 : (_data$search$items$$o = _data$search$items$.offers) == null ? void 0 : (_data$search$items$$o2 = _data$search$items$$o.find(function (offer) {
    var _offer$seller, _structure$route;
    return (offer == null ? void 0 : (_offer$seller = offer.seller) == null ? void 0 : _offer$seller.id) === ((_structure$route = structure.route) == null ? void 0 : _structure$route.sellerId);
  })) == null ? void 0 : _data$search$items$$o2.seller);
  var _useChatUserData = (0,hooks/* useChatUserData */.Cv)({
      structure: structure
    }),
    userData = _useChatUserData.data;
  var _useChatConversation = (0,esm.useChatConversation)({
      sellerId: (seller == null ? void 0 : seller.id) || ((_structure$route2 = structure.route) == null ? void 0 : _structure$route2.sellerId),
      staticProps: staticProps,
      userId: userData == null ? void 0 : userData.id
    }),
    conversation = _useChatConversation.conversation,
    loading = _useChatConversation.loading,
    saveConversationAsRead = _useChatConversation.saveConversationAsRead;
  (0,react.useEffect)(function () {
    saveConversationAsRead();
  }, [saveConversationAsRead]);
  var onReceiveMessages = (0,react.useCallback)(function (messages) {
    var unreadSellerMessages = messages == null ? void 0 : messages.filter(function (message) {
      var _message$moderation;
      var hasApproved = ['REJECTED', 'APPROVED'].includes((_message$moderation = message.moderation) == null ? void 0 : _message$moderation.status);
      return !message.fromUser && hasApproved;
    });
    saveConversationAsRead(unreadSellerMessages.length);
  }, [saveConversationAsRead]);
  var getStore = function getStore() {
    var _conversation$toUser, _conversation$toUser2, _structure$route3;
    if (seller) {
      var sellerName = seller.name || '';
      if (sellerName) {
        return {
          description: sellerName,
          id: seller.id
        };
      }
      return seller;
    }
    return {
      description: (conversation == null ? void 0 : (_conversation$toUser = conversation.toUser) == null ? void 0 : _conversation$toUser.fullName) || '',
      id: (conversation == null ? void 0 : (_conversation$toUser2 = conversation.toUser) == null ? void 0 : _conversation$toUser2.refKey) || ((_structure$route3 = structure.route) == null ? void 0 : _structure$route3.sellerId)
    };
  };
  if ((userData == null ? void 0 : userData.isLogged) === false) {
    return react.createElement(atoms/* Flex */.kC, {
      width: "100%",
      justifyContent: "center",
      alignItems: "center"
    }, react.createElement(atoms/* Text */.xv, null, "Usu\xE1rio n\xE3o autorizado"));
  }
  if (loading || (userData == null ? void 0 : userData.isLogged) === undefined) {
    return react.createElement(atoms/* PageLoading */.SX, null);
  }
  return react.createElement(MessageChainRoot/* default */.Z, {
    "static": staticProps,
    structure: structure,
    store: getStore(),
    conversation: conversation,
    product: data == null ? void 0 : data.product,
    user: userData,
    onReceiveMessages: onReceiveMessages
  });
};
ChatProductMessages.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
ChatProductMessages.ssr = true;
/* harmony default export */ var ChatProductMessages_ChatProductMessages = ((0,withLayoutProps/* default */.Z)(ChatProductMessages));
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatProductMessages/index.js


/***/ }),

/***/ 23740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ChatInbox": function() { return /* reexport */ ChatInbox/* default */.Z; },
  "ChatMessageChain": function() { return /* reexport */ MessageChainRoot/* default */.Z; },
  "ChatProductMessages": function() { return /* reexport */ ChatProductMessages/* default */.Z; }
});

// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatInbox/index.js + 12 modules
var ChatInbox = __webpack_require__(7282);
// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatMessageChain/MessageChainRoot/MessageChainRoot.js + 39 modules
var MessageChainRoot = __webpack_require__(52297);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/ChatMessageChain/index.js

// EXTERNAL MODULE: ../modules/build/esm/components/chat/ChatProductMessages/index.js + 2 modules
var ChatProductMessages = __webpack_require__(82243);
;// CONCATENATED MODULE: ../modules/build/esm/components/chat/index.js




/***/ })

}]);